import React, { useEffect, useState } from "react";
import EbookBanner from "./eookBanner";
import axiosInstance from "../../../util/axiosInstance";
import { Apiurl } from "../../../util/apiurl";
import { useNavigate } from "react-router-dom";
import Loader from "../../layout/lodaer";

function EbookMain() {
  const [ebooks, setEbooks] = useState([]);
  const [loading, setLoading] = useState(false); // Add loading state
  const [showViewAllButton, setShowViewAllButton] = useState(false);
  const [activeCategory, setActiveCategory] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAllEbooks();
  }, []);

  const fetchAllEbooks = async () => {
    setLoading(true); // Start loading
    try {
      const response = await axiosInstance.get(Apiurl.ebookViewAll);
      setEbooks(response.data);
      setActiveCategory(null); // Reset active category when fetching all ebooks
      setShowViewAllButton(false); // Hide the View All button when showing all ebooks
    } catch (error) {
      console.error("Error fetching all ebooks:", error);
    } finally {
      setLoading(false); // End loading
    }
  };

  const fetchCategoryEbooks = async (category) => {
    setLoading(true); // Start loading
    try {
      const response = await axiosInstance.get(`${Apiurl.ebookCategory}/${category}`);
      setEbooks(response.data);
      setActiveCategory(category); // Set the active category
      setShowViewAllButton(true); // Show the View All button when a category is selected
    } catch (error) {
      console.error(`Error fetching ${category} ebooks:`, error);
    } finally {
      setLoading(false); // End loading
    }
  };

  const handleReadMore = (id) => {
    navigate(`/ViewEbbok/${id}`);
  };

  return (
    <>
      <EbookBanner />
      <div className="container">
        <div className="category-section">
          <h3>Book Categories</h3>
          <button
            className={activeCategory === 'finance' ? 'active' : ''}
            onClick={() => fetchCategoryEbooks('finance')}
          >
            Finance
          </button>
          <button
            className={activeCategory === 'technology' ? 'active' : ''}
            onClick={() => fetchCategoryEbooks('technology')}
          >
            Technology
          </button>
        </div>
        <div className="ebook-list-section">
          <div className="head">
            <h2>Browse Popular eBooks</h2>
            {showViewAllButton && <button onClick={fetchAllEbooks}>View All</button>}
          </div>
          {loading ? ( // Show loading indicator when loading
            <Loader/>
          ) : (
            <div className="row">
              {ebooks.map((ebook) => (
                <div className="col-12 col-md-3" key={ebook.id}>
                  <div className="ebook-item">
                    <img src={ebook.coverImage} alt={ebook.bookName} />
                    <div className="book-name">{ebook.bookName}</div>
                    <button onClick={() => handleReadMore(ebook.id)} className="read-btn">Read More <i className="fa fa-angle-double-right"></i></button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default EbookMain;
